import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const navigate = useNavigate();

  const usertype = localStorage.getItem('usertype')?.toLowerCase();

  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();
      setDate(now.toLocaleDateString());
      setTime(now.toLocaleTimeString());
    };

    updateDateTime();
    const interval = setInterval(updateDateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  const allQuickLinks = [
    { name: "Images", path: "/imageslist", icon: "bi-images", roles: ['admin'] },
    { name: "Careers", path: "/career", icon: "bi-briefcase", roles: ['admin'] },
    { name: "Contacts", path: "/contact", icon: "bi-person-lines-fill", roles: ['admin'] },
    { name: "Blogs", path: "/blogslist", icon: "bi-journal-text", roles: ['admin', 'contentadmin'] },
    { name: "Categories", path: "/categorylist", icon: "bi-tags", roles: ['admin'] },
    { name: "Post Content", path: "/postlist", icon: "bi-file-earmark-text", roles: ['admin'] },
    { name: "Page Content", path: "/pagecontentlist", icon: "bi-file-richtext", roles: ['admin'] },
    { name: "Pages", path: "/pages", icon: "bi-file-earmark", roles: ['admin'] },
    { name: "Portfolio", path: "/portfoliolist", icon: "bi-folder", roles: ['admin'] },
    { name: "Testimonials", path: "/testimonialslist", icon: "bi-chat-quote", roles: ['admin'] },
    { name: "Users", path: "/users", icon: "bi-people", roles: ['admin'] },
    { name: "Placed Candidates", path: "/placedCandidates", icon: "bi-people", roles: ['admin'] },
  ];

  const quickLinks = allQuickLinks.filter(link => link.roles.includes(usertype));

  return (
    <div className="container-fluid p-4">

      {/* Welcome Card */}
      <div className="row mb-4">
        <div className="col-12">
          <div
            className="card text-white shadow-lg border-0"
            style={{
              background: "linear-gradient(135deg, #1baed6, #0d6efd)"
            }}
          >
            <div className="card-body py-5 px-4">
              <h2 className="mb-4">
                Welcome to {usertype === 'contentadmin' ? 'Content' : 'Admin'} Dashboard
              </h2>
              <p className="mb-2">
                <strong>Date:</strong> {date}
              </p>

              <p className="mb-0">
                <strong>Time:</strong> {time}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Links */}
      <div className="row">
        <h4 className="mb-3">Quick Links</h4>

        {quickLinks.map((link, index) => (
          <div className="col-lg-2 col-md-3 col-sm-4 mb-3" key={index}>
            <div
              className="card quick-link-card shadow-sm border-0 text-center p-2"
              onClick={() => navigate(link.path)}
              style={{ cursor: 'pointer', transition: '0.3s' }}
            >
              <div className="card-body p-2">
                <i className={`bi ${link.icon} fs-1 mb-2 text-primary`}></i>
                <h6 className="mb-0 text-dark">{link.name}</h6>
              </div>
            </div>
          </div>
        ))}
      </div>
      {quickLinks.length === 0 && (
        <div className="alert alert-warning">
          No quick links available for your account type.
        </div>
      )}
    </div>
  );
};

export default Dashboard;